import { ContainerContent } from 'components/Containers/Containers'
import styled from 'styled-components'

export const QueueDepthChartContent = styled(ContainerContent)`
  align-items: center;
  justify-content: center;
  min-height: 14rem;
`
